import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Animated, StyleSheet } from 'react-native';
import { random } from '../../../game/helpers/helpers';
import Game from '../../shell/Game';
import { isMobile } from '../../shell/utils/platformCheck';
import { TanimationsINT, TimageINT } from '../../store/slices/gameObjectSlice';
import { store } from '../../store/store';
import { Video } from './index';
import { GameNames } from '../../store/slices/GameTypes';
import { sleep } from '../../shell/utils/sleep';

interface TVideoProps {
    image: undefined | Omit<TanimationsINT, "key" | "type">,
    resetTransition: boolean;
}

export const TVideo: React.FC<TVideoProps> = React.memo(({ image, resetTransition }) => {
    const video = useRef<Video>(null);
    const opacity = useRef(new Animated.Value(1));
    const unmounted = useRef(false);
    const loadingVideo = useRef<TanimationsINT>();
    const shouldPlayOnEnded = useRef(false);
    const [paused, setPaused] = useState(false);
    const loopNum = useRef<number>(0);
    const videoNum = useRef(0);
    const [myVideos, setMyVideos] = useState<{ data: { element: React.ReactElement, source: TimageINT; }[], original: TanimationsINT; }>();
    const iterationNum = useRef(0);
    const myVideoRef = useRef<{ data: { element: React.ReactElement, source: TimageINT; }[], original: TanimationsINT; }>();
    const backForVideoEnded = useRef<{ data: { element: React.ReactElement, source: TimageINT; }[], original: TanimationsINT; }>();
    const isRemoving = useRef(false);
    const animationRef = useRef();


    const styles = StyleSheet.create({
        container: {
            position: "absolute",
            width: "100%",
            height: "100%",
        },
        backgroundVideo: {
            position: "absolute",
            width: "100%",
            height: "100%",
            zIndex: -1
        },
    });
    const animate = (value: number = 1) => {
        // console.log("triggered Animate with value", value);
        opacity.current.stopAnimation();
        if (Game.rollback && !value) {
            setMyVideos(undefined);
            // opacity.current.setValue(0);
            return;
        }
        if (isRemoving.current || (value && !myVideoRef.current?.data?.[0].element.props.children.ref.current.paused)) {
            return;
        }
        const imageDuration = store.getState().gameObject.present.image.options?.duration != null ? (store.getState().gameObject.present.image.options?.duration! * 1000) + 100 : 1000;
        // const imageDuration = 3000;
        isRemoving.current = true;
        Animated.timing(opacity.current, {
            toValue: value,
            // TODO: transition is too long, otherwise it jumps to the poster image before switching
            duration: value === 0 ? imageDuration : myVideos?.data?.[0]?.source.options?.duration ? myVideos.data?.[0]?.source.options?.duration * 1000 : myVideos?.data?.[0]?.source.options?.duration === 0 ? 10 : 300,
            useNativeDriver: true
        }).start(({ finished }) => {
            // console.log("jumped to animated finished with value", value, "finished", finished);
            if (value === 0) {
                // console.log("value === 0, loadingVideo.current", loadingVideo.current, myVideoRef.current, loadingVideo.current?.key !== myVideoRef.current?.original.key);
                if (loadingVideo.current && loadingVideo.current?.key !== myVideoRef.current?.original.key) {
                    myVideoRef.current = undefined;
                }
            }
            isRemoving.current = false;
            if (!finished && !value) {
                // console.log("!finished && !value");

                opacity.current.setValue(0);

            } else {

                // setMyVideos(myVideos => undefined);
            }
            if (!loadingVideo.current && (!image || image.sources.length === 0) && finished && value === 0) {

                // setMyVideos(undefined);
            }
            // if (!image) {
            //     setMyVideos(videos => {
            //         if (!videos || !loadingVideo.current) {

            //             // return undefined;
            //         }
            //         return videos;
            //     });

            // }
        });
    };

    const animateVideoTransition = (ref: Animated.AnimatedValue) => {
        if (myVideoRef.current?.data?.[0].source.options?.duration === 0) {
            ref.setValue(1.1);
            return;
        }
        Animated.timing(ref, {
            toValue: 1,
            duration: Game.rollback ? 10 : (myVideoRef.current?.data?.[0].source.options?.duration != null) ? (myVideoRef.current?.data?.[0].source.options.duration * 1000) + 10 : 600,
            useNativeDriver: true
        }).start(({ finished }) => {
            // console.log("finished", finished);
        });
    };
    useEffect(() => {
        unmounted.current = false;

        return () => {
            unmounted.current = true;
        };
    }, []);


    useEffect(() => {

        opacity.current.setValue(0);
        setMyVideos(undefined);

    }, [resetTransition]);


    useEffect(() => {
        // console.log("triggered image", image);

        if ((!image || image.sources.length === 0)) {

            // console.log("NO IMAGE HERE", image);
            loadingVideo.current = undefined;
            // if (Game.rollback) {
            //     setTimeout(() => {
            //         animate(0);
            //     }, 200);

            // } else {

            // }
            animate(0);
            // setMyVideos(myVideos => undefined);
            // setMyVideos(undefined);
            // setPaused(false);
            return;
        }
        if (Game.rollback && myVideoRef.current?.data?.[0].source.key === (image as TanimationsINT).key) {

            opacity.current.setValue(1.1);
            // if (myVideoRef.current?.data?.[0].element.props.children.ref.current?.play) {
            //     myVideoRef.current.data[0].element.props.children.ref.current.currentTime = 0;
            //     myVideoRef.current?.data?.[0].element.props.children.ref.current?.play();
            // }
            if (myVideoRef.current?.data?.[0].element.props.children.ref.current && image.options?.speed && myVideoRef.current?.data?.[0].element.props.children.ref.current?.playbackRate !== image.options.speed) {
                myVideoRef.current.data[0].element.props.children.ref.current.playbackRate = image.options.speed;
            } else if (myVideoRef.current?.data?.[0].element.props.children.ref.current && myVideoRef.current?.data?.[0].element.props.children.ref.current.playbackRate !== 1) {
                myVideoRef.current.data[0].element.props.children.ref.current.playbackRate = 1;
            }
            // myVideoRef.current?.data?.[0].source.options = image.options;
            // setMyVideos(videos => [...videos!]);

            // returning here fixes a bug when you rollback and fourth an animation (prevents a weird jump)
            return;
        } else if (myVideoRef.current?.original.key === (image as TanimationsINT).key) {
            if (myVideoRef.current?.data?.[0]?.element.props.children.ref?.current?.paused) {

                myVideoRef.current?.data?.[0]?.element.props.children.ref?.current.play();
            } else {
                return;
            }

        }

        loadingVideo.current = image as TanimationsINT;
        // myVideos = { ...image };
        videoNum.current = 0;

        let newVideos = image.sources.map((video, i) => {
            // return { ...video, key: `${video.key}_${i}` };
            // TODO: fix transition
            // return { element: videoElement({ ...video, key: `${video.key}_${i}` }, i, !myVideos ? 1 : 1), source: video };
            return { element: videoElement({ ...video, key: `${video.key}_${i}` }, i, image.sources.length > 1 ? new Animated.Value(1) : new Animated.Value(myVideoRef?.current?.data?.[0]?.source.options?.duration ? 0 : 1)), source: video };
        });
        if (image.sources.length === 1 && myVideoRef.current) {
            if (newVideos.find(video => myVideoRef.current?.data?.[0].source.key !== video.source.key)) {
                newVideos.push(myVideoRef.current.data?.[0]);
            }
        }
        // image.sources?.forEach(video => {
        //     if (!myVideos?.find(videoSrc => videoSrc.source.key === video.key)) {
        //         newVideos.push(video);
        //     }
        // });
        if (myVideoRef.current?.data?.[1]?.element.props?.children?.ref?.current) {
            myVideoRef.current.data[1].element.props.children.ref.current.currentTime = 0;
        }
        setTimeout(async () => {
            //     await sleep(0.5);
            // }
            if (image.options?.waitForEnd) {
                backForVideoEnded.current = { data: newVideos, original: image as TanimationsINT };
                shouldPlayOnEnded.current = true;
                if (!myVideoRef.current) {

                    setMyVideos(myVideos => ({ data: newVideos, original: image as TanimationsINT }));
                }

            } else {
                backForVideoEnded.current = undefined;
                shouldPlayOnEnded.current = false;
                setMyVideos(myVideos => ({ data: newVideos, original: image as TanimationsINT }));

            }
            // TODO: find a better way to fix this
            // Temp fix - when you rollback and forward on animations it shows the previous poster
            // example in scene: V8_AnnWebcam where there are 3 animations in a row
        }, 100);
        // setVideoRef(myVideos.data?.[0]);

    }, [image]);
    const onEndedVideo = useCallback((index: number) => {

        if (!image || !myVideoRef.current) { return; }
        video.current?.seek(0);
        if (shouldPlayOnEnded.current && backForVideoEnded.current && (backForVideoEnded.current?.original?.key !== (image as TanimationsINT)?.key)) {
            setMyVideos(v => backForVideoEnded.current);
            shouldPlayOnEnded.current = false;
            backForVideoEnded.current = undefined;
            return;
        }

        if (myVideoRef.current?.data?.[0]?.source.options?.loop === undefined) {
            setPaused(p => !p);
            loopNum.current++;
            return;
        }


        if (loopNum.current !== 0) {
            if (iterationNum.current < loopNum.current) {
                iterationNum.current++;
                setPaused(p => !p);
            } else {
                videoNum.current++;
                const currentVideo = myVideoRef.current?.data?.[0];
                const copyVideos = [...myVideoRef.current.data];
                copyVideos.shift();
                copyVideos.push(currentVideo);


                let newVideos = copyVideos.map((_video, i) => {
                    const video = _video.source;
                    return { element: videoElement({ ...video, key: `${video.key}_${i}` }, i, image.sources.length > 1 ? new Animated.Value(1) : new Animated.Value(myVideoRef?.current?.data?.[0]?.source.options?.duration ? 0 : 1)), source: video };
                });
                setMyVideos(v => ({ data: newVideos, original: v!.original }));
            }
        } else {
            if (myVideoRef.current.original.options?.loop === 0) {
                return;
            }
            setPaused(p => !p);
        }

    }, [image, myVideoRef, video, loopNum, iterationNum, setPaused, setMyVideos]);

    const videoElement = useCallback((videoSrc: TimageINT, i: number, opacity: Animated.AnimatedValue | number) => {
        return <Animated.View key={videoSrc?.key} style={{ position: "absolute", height: "100%", width: "100%", opacity }}>

            <Video
                rate={image?.sources[0].options?.speed || 1}
                paused={i !== 0}
                // seek={0}
                repeat={false}
                onEnd={() => onEndedVideo(i)}
                source={videoSrc?.url as any}
                ref={isMobile() ? video : React.createRef()}
                poster={videoSrc?.poster?.url?.toString()}
                resizeMode={"cover"}
                style={styles.backgroundVideo} />
        </Animated.View>;
    }, [isMobile, onEndedVideo, styles.backgroundVideo]);



    useEffect(() => {
        myVideoRef.current = myVideos;
        if (!myVideos) { return; }
        if (Array.isArray(myVideos.data?.[0]?.source.options?.loop)) {
            loopNum.current = random(myVideos.data?.[0]?.source.options?.loop[0]!, myVideos.data?.[0]?.source.options?.loop[1]!);

        } else {
            loopNum.current = myVideos.data?.[0]?.source.options?.loop ? myVideos.data?.[0]?.source.options?.loop : 0;
        }
        iterationNum.current = 1;


        setPaused(p => !p);
        // console.log("sending to animate", myVideos, "myVideoRef.current", myVideoRef.current, "loadingVideo.current", loadingVideo.current);
        if (loadingVideo.current) {
            animate();
        }

    }, [myVideos]);



    // Hacky way to control the loop on Android
    useEffect(() => {

        if (image?.sources && image?.sources.length > 1) {

            if (myVideos && myVideos.data.length > 1 && myVideos.data?.[0]?.element.props?.children?.ref?.current?.currentTime != null) {
                myVideos.data[myVideos.data.length - 1].element.props.children.ref.current.currentTime = 0;
            }
        } else {

        }
        if (myVideos?.data?.[0]?.element.props.style.opacity.setValue) {

            animateVideoTransition(myVideos?.data?.[0]?.element.props.style.opacity);

        }
        // if (!store.getState().advance.skipping) {
        //     myVideos?.data?.[0]?.element.props?.children?.ref?.current?.play?.();

        // }
        if (loopNum.current && myVideos?.data?.[0]?.element.props?.children?.ref?.current.paused && !store.getState().advance.skipping || store.getState().gameObject.present.waitInput) {
            if (image) {
                opacity.current.setValue(1);
            }
            myVideos?.data?.[0]?.element.props?.children?.ref?.current?.play?.();
        } else if (!loopNum.current && myVideos?.data?.[0]?.element.props?.children?.ref?.current.paused) {
            if (image) {
                opacity.current.setValue(1);
            }
            myVideos?.data?.[0]?.element.props?.children?.ref?.current?.play?.();
        } else {

        }

        // animateVideoTransition();
        // setPaused(false);


    }, [paused]);
    return (
        <>
            <Animated.View style={[styles.container, { opacity: opacity.current }]}>
                {
                    myVideos?.data?.map((videoSrc, i) => (
                        videoSrc.element

                    )).reverse()
                }
            </Animated.View>
        </>
    );
});